import React from 'react';
import { useSetRecoilState } from 'recoil';
import { overlayProppress } from '../../atoms/OverlayProgress';
import { flashMessageSuccess, flashMessageError } from '../../atoms/FlashMessage';
import { zshDialog } from '../../atoms/ZshDialog';
import { RouteComponentProps } from 'react-router-dom';
import DataTable, { DataTableRowsProps, DataTableBtnGroupProps, DataTableSearchParamsProps } from '../../components/View/DataTable';
import { searchFilterProps } from '../../components/View/SearchFilter';
import * as _data_actions from '../../helper/dataActions';

function RolesIndex({ history, location }: RouteComponentProps) {

  const setOverlayProppress = useSetRecoilState(overlayProppress);
  const setFlashMessageSuccess = useSetRecoilState(flashMessageSuccess);
  const setFlashMessageError = useSetRecoilState(flashMessageError);
  const setZshDialog = useSetRecoilState(zshDialog);

  const clickCell = (callbackParams: any) => {
    history.push(location.pathname + '/' + callbackParams.data.id);
  }

  const handleToAdd = () => {
    history.push('/roles/add');
  }

  const confirmDelete = (params: any) => {
    if (params.selected.length > 0) {
      _data_actions.showConfirmDialog({
        dialogType: 'delete',
        funcAgree: () => {
          handleDelete(params);
        },
        setZshDialog
      });
    } else {
      setFlashMessageError('項目を選択してください');
    }
  }

  const handleDelete = (params: any) => {
    _data_actions.deleteData({
      deleteUrl: 'roles/delete/',
      selected: params.selected,
      getData: params.getData,
      setOverlayProppress,
      setFlashMessageSuccess,
      setFlashMessageError
    });
  }

  const rows: DataTableRowsProps[] = [
    {
      label: 'ID',
      value: 'id',
      sortField: 'Roles.id',
      align: 'left',
    },
    {
      label: '権限グループ名',
      value: 'name',
      sortField: 'name',
      align: 'left'
    },
    {
      label: '登録日時',
      value: 'created',
      filter: 'YMDHm',
      sortField: 'Roles.created',
      align: 'left',
    },
    {
      label: '更新日時',
      value: 'modified',
      filter: 'YMDHm',
      sortField: 'Roles.modified',
      align: 'left',
    },
  ];

  const searchParams: DataTableSearchParamsProps[] = [
    {
      title: '権限グループ名',
      text: '部分一致',
    },
  ];

  const searchProps: searchFilterProps[] = [
    {
      key: 'search'
    },
  ];

  const btnGroup: DataTableBtnGroupProps[] = [
    {
      title: '新規追加',
      func: handleToAdd,
      color: 'primary'
    },
    {
      title: '削除',
      func: confirmDelete,
      color: 'default'
    },
  ];

  return (
    <div className="content-1">
      <DataTable
        rows={rows}
        checkbox={true}
        dataKey='roles'
        jsonPath='roles/index/index.json'
        urlQuery={true}
        parentProps={{ history, location }}
        handleClickCell={clickCell}
        searchParams={searchParams}
        searchProps={searchProps}
        btnGroup={btnGroup}
      />
    </div>
  )
}

export default RolesIndex;